var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"txm"},[_vm._t("trigger",null,{"toggle":_vm.toggle,"open":_vm.open}),(_vm.open)?_c('div',{ref:"menu",staticClass:"txm-menu",class:[`txm-align-${_vm.align}`, _vm.menuClass],attrs:{"role":"menu"}},[_vm._t("default",null,{"close":_vm.close})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }